<script>
  import { _ as t } from "svelte-i18n";
  import { navigate } from "svelte-routing";
  import { Icon } from "t2c-components";

  const handleClickHome = () => {
    navigate("/");
  };
  const handleClickPersonalData = () => {
    navigate("/personal");
  };
  const handleClickSettings = () => {
    navigate("/settings");
  };
</script>

<footer class="mobile-footer">
  <div class="footer-item">
    <Icon medium on:click={handleClickHome} icon="home" fill="currentColor" />
    <div class="footer-text">{$t("dashboard")}</div>
  </div>
  <div class="footer-item">
    <Icon
      medium
      on:click={handleClickPersonalData}
      icon="user"
      fill="currentColor"
    />
    <div class="footer-text">{$t("personalData")}</div>
  </div>
  <div class="footer-item">
    <Icon
      medium
      on:click={handleClickSettings}
      icon="settings"
      fill="currentColor"
    />
    <div class="footer-text">{$t("settings")}</div>
  </div>
</footer>

<style>
  .mobile-footer {
    background-color: #eee;
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    padding: 12px 0;
  }

  @media only screen and (min-width: 600px) {
    .mobile-footer {
      display: none;
    }
  }

  .footer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--accent);
  }

  .footer-text {
    font-size: 12px;
    text-align: center;
  }
</style>
